module.exports = __webpack_public_path__ + "static/media/banner.db9b5a8f.jpg";